import {
  cloneElement,
  useEffect,
  useLayoutEffect,
  useRef,
  useState,
} from 'react';
import InternalIconButton from '@/components/chat-history/IconButton';
import { observer } from 'mobx-react-lite';
import ModelSelect from '@/pages/chat/components/input/ModelSelect';
import modelChoiceStore from '../model-choice/store';
import client, { SIZE_MODEL_BIG, SIZE_MODEL_SMALL } from '@/store/client';
import settingStore from './setting/store';
import wsStore from './store';
import appLogger from '@public/log/monitor';
import navbarStore from '@/store/navbar';

function SettingsBar(props) {
  const store = wsStore.currentStore || {};
  const { list: modelList } = modelChoiceStore;
  const { currAsstId } = store;

  useEffect(() => {
    // 可选模型
    modelChoiceStore.getList();
  }, []);

  return (
    <div className="w-full flex justify-between items-center">
      <ModelSelect
        activeKey={currAsstId}
        items={modelList}
      />
      <section className="flex gap-2px">
        <IconButton
          icon="setting"
          tooltip="设置"
          onClick={() => {
            appLogger.log({
              key : "aibot_plugin",
              action : "click",
              arrt : "aibot_plugin_sidebar_set",
            });
            settingStore.show();
          }}
        />
        <IconButton
          icon="clock"
          tooltip="历史"
          onClick={() => {
            appLogger.log({
              key : "aibot_plugin",
              action : "click",
              arrt : "aibot_plugin_sidebar_history",
            });
            wsStore.doWhenLogin(() => {
              client.changeSize(SIZE_MODEL_BIG);
            });
          }}
        />
        <IconButton
          disabled={store.isAITyping}
          icon="create"
          tooltip="新建对话"
          className={store.isAITyping ? '!opacity-30' : 'bg-[#F0F2F5]'}
          onClick={
            () => {
              appLogger.log({
                key : "aibot_plugin",
                action : "click",
                arrt : "aibot_plugin_sidebar_newchat",
              });
              wsStore.newChat();
            }
          }
        />
      </section>
    </div>
  );
}

function IconButton({ disabled, icon, onClick, tooltip, className = '' }) {
  return (
    <InternalIconButton
      className={`!rounded-full opacity-100 ${className}`}
      disabled={disabled}
      iconClassName="size-20px"
      icon={icon}
      tooltip={tooltip}
      onClick={event => {
        event.stopPropagation();
        onClick(event);
      }}
    />
  );
}

export default observer(SettingsBar);
